import type { Language } from './types';
import { getLoadedTranslations } from './translations';
import { DEFAULT_LANGUAGE } from './languages';

export const translateStatus = (status: string, t: (key: string) => string): string => {
  if (!status) return t('no_data');
  const normalizedStatus = status.toLowerCase().replace(/\s+/g, '_');
  return t(`status_${normalizedStatus}`) || status;
};

export const translateField = (fieldName: string, t: (key: string) => string): string => {
  if (!fieldName) return t('no_data');
  const normalizedField = fieldName.toLowerCase().replace(/\s+/g, '_');
  return t(`field_${normalizedField}`) || fieldName;
};

export const translateAppointmentType = (type: string, t: (key: string) => string): string => {
  if (!type) return t('no_data');
  return t(`appointment_${type}`) || type;
};

export const translatePaymentMethod = (method: string, t: (key: string) => string): string => {
  if (!method) return t('no_data');
  const normalizedMethod = method.toLowerCase().replace(/\s+/g, '_');
  return t(`payment_${normalizedMethod}`) || method;
};

export const translateCommunicationChannel = (channel: string, t: (key: string) => string): string => {
  if (!channel) return t('no_data');
  return t(`channel_${channel}`) || channel;
};

export const translateWishlistCategory = (category: string, t: (key: string) => string): string => {
  if (!category) return t('no_data');
  return t(`wishlist_${category}`) || category;
};

export const translateWishlistSource = (source: string, t: (key: string) => string): string => {
  if (!source) return t('no_data');
  return t(`source_${source}`) || source;
};

export const getFullName = (firstName?: string, lastName?: string, t?: (key: string) => string): string => {
  if (!firstName && !lastName) return t?.('no_data') || '-';
  return [firstName, lastName].filter(Boolean).join(' ');
};

export const formatOrderWithCustomer = (
  orderNo: string, 
  customerName: string, 
  t: (key: string) => string
): string => {
  return `${t('order')} #${orderNo} - ${customerName}`;
};

export const getTranslation = (key: string, language?: Language, params?: Record<string, any>): string => {
  const rawLang = language || (document.documentElement.lang as Language) || DEFAULT_LANGUAGE;
  const normalizedLang = rawLang.split(/[-_]/)[0] === 'uk' ? 'ua' : rawLang.split(/[-_]/)[0];
  const translation =
    getLoadedTranslations(normalizedLang)?.[key] ||
    getLoadedTranslations(DEFAULT_LANGUAGE)?.[key] ||
    key;
  
  if (!params) return translation;
  
  return Object.entries(params).reduce(
    (result, [paramKey, paramValue]) =>
      result.replace(new RegExp(`{{${paramKey}}}`, 'g'), String(paramValue)),
    translation
  );
};
